var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-item"},[_c('div',{staticClass:"resume-item__label"},[_vm._t("label_sx"),_vm._t("icon")],2),_c('div',{staticClass:"resume-item__label"},[_vm._t("label_dx")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }